import { store } from '@redux/store';

export const waitForWolfieReady = () => {
  return new Promise<void>((resolve) => {
    const checkState = () => {
      const state = store.getState();
      const isLoading = state?.wolfie?.loading;
      const hasNewMessages = state?.wolfie?.newMessages?.length > 0;

      if (!isLoading && !hasNewMessages) {
        resolve();
      } else {
        setTimeout(checkState, 100);
      }
    };

    checkState();
  });
};
